var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"assistant"}},[_c('vehicleNavBar',{model:{value:(_vm.updateTabs),callback:function ($$v) {_vm.updateTabs=$$v},expression:"updateTabs"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }